module.exports = __webpack_public_path__ + "img/M03.8ca78b6f.png";